module.exports = __webpack_public_path__ + "img/18.4d68d7ee.jpg";